import { gql, useMutation } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { KycBeginVerificationInput, KycBeginVerificationPayload } from "@oysterhr/schema"
import { VerificationStatusFields } from "../fragments/VerificationStatusFields"

export interface BeginVerificationData {
  beginKycVerification: KycBeginVerificationPayload
}

const KYC_TEAM_MEMBER_BEGIN_VERIFICATION = gql`
  mutation KycTeamMemberBeginVerification($userId: ID!) {
    beginKycVerification(input: { userId: $userId }) {
      user {
        id
        latestKycVerification {
          ...VerificationStatusFields
        }
      }
      errors
    }
  }
  ${VerificationStatusFields}
`

export const useBeginVerification = (
  options?: InjectedOptions<BeginVerificationData, KycBeginVerificationInput>,
) =>
  useMutation<BeginVerificationData, KycBeginVerificationInput>(
    KYC_TEAM_MEMBER_BEGIN_VERIFICATION,
    options,
  )
